/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar, Card, Checkbox, Image, Popover, Tag, Typography } from "antd";
import { useState } from "react";
import { formatEstimatedHrs } from "../../../../config/utils";
import { useAppSelector } from "../../../../config/hooks";

interface PropsType {
  task: any;
}
export default function AddressPop(props: PropsType) {
  const { task } = props;
  const [openDetailPopup, setOpenDetailPopUp] = useState<boolean>(false);
  const handleOpenChange = (newOpen: boolean) => {
    setOpenDetailPopUp(newOpen);
  };
  const schedulingFormData = useAppSelector(
    (state) => state?.schedule?.schedulingFormData
  );
  const crewLeaderName = schedulingFormData?.data?.crews?.find(
    (crew: any) => crew.id === task?.crew_id
  )?.crewLeader;
  return task?.type === "task" ? (
    <Checkbox value={task.id} key={task.id} className="task-card">
      <div className="shadow_checkbox" />
      <Card className="fc-event-sidebar" data-id={task.id} draggable="true">
        <Typography.Text
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "16px",
            fontWeight: "700",
            color: "#151718",
            lineHeight: "24px",
            marginBottom: "4px",
          }}
        >
          <span
            style={{
              whiteSpace: "pre-wrap",
              maxWidth: "180px",
            }}
          >
            {task.name}
          </span>

          <div
            style={{
              display: "flex",
              fontSize: "12px",
              fontWeight: "400",
              color: "#151718",
              gap: 4,
              justifyContent: "flex-end",
            }}
          >
            {task?.total_no_of_visits > 1 && (
              <>
                <img src="/images/schedule/recurring-icon.svg" alt="icon" />
                {task?.scheduled_no_of_visits}/{task?.total_no_of_visits}
              </>
            )}
          </div>
        </Typography.Text>
        <div className="task-details">
          <Typography.Text
            type="secondary"
            style={{
              fontSize: "14px",
              fontWeight: "600",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "#070707",
              maxWidth: "170px",
              minWidth: 0,
            }}
          >
            {task.property_name}
          </Typography.Text>
          {/* <Tag
            className="default-tag"
            style={{
              fontSize: "12px",
              color: "#151718",
              backgroundColor: "#E7F9F3",
              border: "1px solid #E7F9F3",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              borderRadius: "10px",
            }}
          >
            <Image
              src="/images/potential-deals/time-icon.svg"
              width={12}
              preview={false}
            />
            {task?.total_no_of_visits > 1
              ? formatEstimatedHrs(task.hrs_per_visit)
              : formatEstimatedHrs(task.estimated_hrs)}
          </Tag> */}
        </div>
      </Card>
    </Checkbox>
  ) : (
    <Popover
      arrow={false}
      content={
        <div className="unschedule_property_detail">
          <div className="detail_header">
            <h3>{task?.name}</h3>
            {/* <div className="right_btns">
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => e.stopPropagation()}
                style={{
                  padding: "0px",
                  height: "28px",
                  width: "28px",
                  border: "1px solid #DEE5E6",
                  backgroundColor: "transparent",
                }}
                className="status_dropdown"
                icon={
                  <ArrowRightIcon style={{ transform: "rotate(-50deg)" }} />
                }
              />
            </div> */}
          </div>
          <div className="visitAddress">
            <div className="visitWrapper">
              <div className="visitTiming">
                <label>Contract:</label>
                <h4>{task?.contract_name}</h4>
              </div>
              <div className="visitTiming">
                <label>Crew:</label>
                <Tag className="default-tag">
                  {task?.crew_or_contractor_name}{" "}
                  {crewLeaderName?.first_name
                    ? " - " + crewLeaderName?.first_name
                    : ""}{" "}
                  {crewLeaderName?.last_name ?? ""}
                </Tag>
              </div>
            </div>

            <div className="addressImage">
              <Avatar
                size={40}
                src={
                  task?.property?.image_url ||
                  "/images/company/no_image_grey.png"
                }
              />
              <div className="addressInfo">
                <h5>{task?.property_name}</h5>
                <div className="addressLabel">
                  <Image
                    src="/images/estimate/address-icon.svg"
                    preview={false}
                    width={12}
                  />
                  <p>{task?.property?.address}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      trigger="hover"
      open={openDetailPopup}
      onOpenChange={handleOpenChange}
      placement="rightTop"
      //   getPopupContainer={(trigger) => trigger.parentElement || document.body}
    >
      <Checkbox
        value={task.id}
        key={task.id}
        className={task?.type === "task" ? "task-card" : "wo-card"}
      >
        <div className="shadow_checkbox" />
        <Card className="fc-event-sidebar" data-id={task.id} draggable="true">
          <Typography.Text
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "16px",
              fontWeight: "700",
              color: "#151718",
              lineHeight: "24px",
              marginBottom: "4px",
            }}
          >
            <span
              style={{
                whiteSpace: "pre-wrap",
                maxWidth: "180px",
              }}
            >
              {task.name}
            </span>

            <div
              style={{
                display: "flex",
                fontSize: "12px",
                fontWeight: "400",
                color: "#151718",
                gap: 4,
                justifyContent: "flex-end",
              }}
            >
              {task?.total_no_of_visits > 1 && (
                <>
                  <img src="/images/schedule/recurring-icon.svg" alt="icon" />
                  {task?.scheduled_no_of_visits}/{task?.total_no_of_visits}
                </>
              )}
            </div>
          </Typography.Text>
          <div className="task-details">
            <Typography.Text
              type="secondary"
              style={{
                fontSize: "14px",
                fontWeight: "600",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: "#070707",
                maxWidth: "170px",
                minWidth: 0,
              }}
            >
              {task.property_name}
            </Typography.Text>
            <Tag
              className="default-tag"
              style={{
                fontSize: "12px",
                color: "#151718",
                backgroundColor: "#E7F9F3",
                border: "1px solid #E7F9F3",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                borderRadius: "10px",
              }}
            >
              <Image
                src="/images/potential-deals/time-icon.svg"
                width={12}
                preview={false}
              />
              {task?.total_no_of_visits > 1
                ? formatEstimatedHrs(task.hrs_per_visit)
                : formatEstimatedHrs(task.estimated_hrs)}
            </Tag>
          </div>
        </Card>
      </Checkbox>
    </Popover>
  );
}
